import { OrderStateStatus } from './order-state-status.enum';

export const ORDER_STATUS_CLASSNAME = {
  [OrderStateStatus.PLACED]: 'placed',
  [OrderStateStatus.CANCELED]: 'canceled',
  [OrderStateStatus.CONFIRMED]: 'confirmed',
  [OrderStateStatus.SHIPPED]: 'shipped',
  [OrderStateStatus.WAITING_FOR_PAYMENT]: 'canceled',
};
